import axios, { AxiosInstance } from 'axios'

export const rdfRestClient: AxiosInstance = axios.create({
  baseURL: import.meta.env.VITE_RDF_REST_API_URL,
})
